import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import { environment } from '../../../../environments/environment';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent implements OnInit {

	formResetPassword: FormGroup;
    passwordFirst:string = '';
    passwordSecond:string = '';
    token: string = '';
    resetOk: boolean = false;
    error: string = '';

  constructor(private activatedRoute: ActivatedRoute, private fb: FormBuilder, private http: HttpClient) { }

  ngOnInit() {
  	// get route param
    this.activatedRoute.params.subscribe((params: Params) => {
        this.token = params['token'];
      });

  	this.formResetPassword = this.fb.group({
	      'passwordFirst' : [null, Validators.required],
	      'passwordSecond' : [null, Validators.required]
	    });
  }

  resetPwd(data){

  	let body = '{' +
            '"token": "' + this.token + '",' +
            '"plainPassword": ' + 
                '{"first": "' + data.passwordFirst + '",' +
                '"second": "' + data.passwordSecond + '"}' +
        '}';
    this.error = '';
    console.log(body);

    this.http.put(environment.apiResetPwd, body)
        .map((res: Response) => res )
        .subscribe(
        	data => {
        		this.resetOk = true;
        	},
    		err => {
    			this.error = JSON.parse(err['error']).message;
    		}
	  	);

  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/components/users/reset-password/reset-password.component.ts